import { render, staticRenderFns } from "./LoadingMask.vue?vue&type=template&id=78851f58&scoped=true"
import script from "./LoadingMask.vue?vue&type=script&lang=ts"
export * from "./LoadingMask.vue?vue&type=script&lang=ts"
import style0 from "./LoadingMask.vue?vue&type=style&index=0&id=78851f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78851f58",
  null
  
)

export default component.exports